import { IconPhoto } from "@tabler/icons-react"
import { type FC } from "react"

interface PreviewProps {
	title: string
	description: string
	imageFileUrl: string
	domain: string
}

const Preview: FC<PreviewProps> = ({ title, description, imageFileUrl, domain }) => (
	<div className="border-component-border max-w-sm overflow-hidden rounded-xl border bg-white">
		{imageFileUrl ? (
			<img src={imageFileUrl} alt="Academy sharing thumbnail" className="aspect-[1.91/1] w-full object-cover" />
		) : (
			<div className="bg-component-background flex aspect-[1.91/1] flex-col items-center justify-center gap-2 px-4 text-center text-gray-400">
				<IconPhoto size={24} stroke={1.25} aria-hidden="true" />
				<p className="text-xs">Your thumbnail will appear here</p>
			</div>
		)}
		<div className="border-component-border space-y-1.5 border-t p-3">
			<p className="truncate text-xs text-gray-500">{domain}</p>
			<h4 className="line-clamp-2 text-sm font-semibold wrap-anywhere text-gray-900">
				{title || "Your academy name"}
			</h4>
			<p className="line-clamp-2 text-xs leading-relaxed wrap-anywhere text-gray-500">
				{description.trim() || "Add a description to introduce your academy."}
			</p>
		</div>
	</div>
)

export default Preview
